
import React, { createContext, useContext, useState } from 'react';

const MaintenanceContext = createContext();

// Initial state'i URL'den oku
const getInitialMaintenanceState = () => {
  const queryParams = new URLSearchParams(window.location.search);
  const bakim = queryParams.get('bakim');
  return bakim === 't';
};

// Provider bileşeni
export const MaintenanceProvider = ({ children }) => {
  const [isMaintenanceMode, setIsMaintenanceMode] = useState(getInitialMaintenanceState);

  return (
    <MaintenanceContext.Provider value={{ isMaintenanceMode }}>
      {children}
    </MaintenanceContext.Provider>
  );
};

// Custom hook
export const useMaintenanceMode = () => useContext(MaintenanceContext);